import { useCallback, useState } from 'react';

import { useParticipantsModal } from '@features/tournament/ui/components/ParticipantsModal/useParticipantsModal';
import { ParticipantsTab } from '@features/tournament/ui/components/TournamentParticipantsEdit/types';

export function useModal(
  clubId: string,
  tournamentId: string,
  refetchParticipants: () => void,
  tab: ParticipantsTab,
) {
  const [modalVisible, setModalVisible] = useState(false);

  const onModalVisibleChange = useCallback(
    (newValue: boolean) => {
      setModalVisible(newValue);
      if (!newValue) {
        refetchParticipants();
      }
    },
    [refetchParticipants],
  );

  const hideModal = useCallback(() => onModalVisibleChange(false), [onModalVisibleChange]);
  const showModal = useCallback(() => onModalVisibleChange(true), [onModalVisibleChange]);

  const modalProps = useParticipantsModal({
    clubId,
    tournamentId,
    tab,
    disabled: !modalVisible,
  });

  return {
    modalVisible,
    hideModal,
    showModal,
    modalProps,
  };
}
